// utils/toast.js
import { toast } from "react-toastify";

function getRandomSuccessEmojis(status) {
  let emojis = ["✅", "🎉", "👍", "🙌", "😄", "✔️", "👏", "💪", "🎊", "🥳"];
  if (status === "error") {
    emojis = ["❌", "🚫", "⚠️", "🔴", "💔", "😢", "👎", "🙅‍♀️", "🙅‍♂️", "🛑"];
  }

  if (emojis.length < 2) {
    throw new Error("Need at least two emojis in the array");
  }

  let firstRandomIndex = Math.floor(Math.random() * emojis.length);
  let secondRandomIndex = Math.floor(Math.random() * emojis.length);

  while (firstRandomIndex === secondRandomIndex) {
    secondRandomIndex = Math.floor(Math.random() * emojis.length);
  }

  const firstEmoji = emojis[firstRandomIndex];
  const secondEmoji = emojis[secondRandomIndex];

  return [firstEmoji, secondEmoji];
}

export const displaySuccessToast = (message) => {
  const [beginningEmoji, endEmoji] = getRandomSuccessEmojis();
  const formattedMessage = `${beginningEmoji} ${message} ${endEmoji}`;

  toast.success(formattedMessage, {
    position: toast.POSITION.BOTTOM_RIGHT,
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

export const displayErrorToast = (message) => {
  const [beginningEmoji, endEmoji] = getRandomSuccessEmojis("error");
  const formattedMessage = `${beginningEmoji} ${message} ${endEmoji}`;
  toast.error(formattedMessage, {
    position: toast.POSITION.BOTTOM_RIGHT,
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};
